import * as Types from 'actions/types';

export default function (state={},action){
    switch(action.type){
        case Types.LOGIN:
            return { ...state, ID: action.payload.userID, clientID: action.payload.clientID, userName: action.payload.userName, clientName: action.payload.clientName };
        case Types.FETCH_USER:
            return {...state,...action.payload};
        case Types.LOGOUT:
            return {};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js